<template>
  <div class="cart-panel">
    <div class="cart-header">
      <span>订单明细</span>
      <div
        class="tool-chip"
        :class="{ active: isVip }"
        @click="handleToggleVip"
      >
        VIP
      </div>
    </div>
    <div class="cart-items">
      <div
        v-for="item in cartItems"
        :key="item.uid"
        class="c-item"
      >
        <img
          v-if="item.coverPhoto"
          :src="item.coverPhoto"
          class="c-item-img"
          @error="handleImageError"
        />
        <div class="c-info">
          <div style="font-weight:bold;">
            {{ item.name }}
            <span v-if="item.specName" style="font-size:12px;color:#999"> {{ item.specName }}</span>
          </div>
          <div style="color:#FF6B6B; font-size:14px;">¥{{ item.price.toFixed(2) }}</div>
        </div>
        <div class="qty-box">
          <button class="q-btn" @click="handleModifyQty(item.uid, -1)">-</button>
          <div class="q-num">{{ item.qty }}</div>
          <button class="q-btn" @click="handleModifyQty(item.uid, 1)">+</button>
        </div>
      </div>
      <div v-if="cartItems.length === 0" style="text-align: center; margin-top: 50px; color: #ccc;">
        暂无商品
      </div>
    </div>
    <!-- 会员信息展示区 -->
    <div v-if="member" class="member-info-section">
      <span class="member-text">
        {{ member.tel }}/余额：{{ member.balance.toFixed(0) }}元/积分：{{ member.integralAmount.toFixed(0) }}
      </span>
      <i class="fas fa-times" @click="handleClearMember" style="cursor: pointer; color: #999; margin-left: 10px;"></i>
    </div>

    <div class="cart-footer">
      <div style="display:flex; justify-content:space-between; margin-bottom:10px;">
        <span>小计:</span>
        <span>¥{{ subTotal.toFixed(2) }}</span>
      </div>
      <div
        v-if="isVip && discountAmount > 0"
        style="display:flex; justify-content:space-between; margin-bottom:10px; color:#E67E22;"
      >
        <span>折扣:</span>
        <span>-¥{{ discountAmount.toFixed(2) }}</span>
      </div>
      <div style="display:flex; justify-content:space-between; font-size:20px; font-weight:bold; margin-bottom:15px;">
        <span>总计:</span>
        <span>¥{{ totalPrice.toFixed(2) }}</span>
      </div>
      <button class="checkout-btn" @click="handleCheckout" :disabled="cartItems.length === 0">
        <span>去结算</span>
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MealCartPanel',
  props: {
    cartItems: {
      type: Array,
      default: () => []
    },
    isVip: {
      type: Boolean,
      default: false
    },
    member: {
      type: Object,
      default: null
    }
  },
  computed: {
    subTotal() {
      return this.cartItems.reduce((sum, item) => sum + (item.price * item.qty), 0)
    },
    discountAmount() {
      if (!this.isVip) return 0
      return this.subTotal * 0.12 // VIP 88折，折扣12%
    },
    totalPrice() {
      return this.subTotal - this.discountAmount
    }
  },
  methods: {
    handleModifyQty(uid, delta) {
      this.$emit('modify-qty', uid, delta)
    },
    handleImageError(e) {
      e.target.style.display = 'none'
    },
    handleToggleVip() {
      this.$emit('toggle-vip')
    },
    handleClearMember() {
      this.$emit('clear-member')
    },
    handleCheckout() {
      if (this.cartItems.length === 0) {
        this.$message && this.$message.warning('购物车为空')
        return
      }
      this.$emit('checkout', {
        totalPrice: this.totalPrice,
        subTotal: this.subTotal,
        discountAmount: this.discountAmount
      })
    }
  }
}
</script>

<style scoped>
.cart-panel {
  width: 360px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: -5px 0 20px rgba(0, 0, 0, 0.03);
  z-index: 20;
}

.cart-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-items {
  flex: 1;
  overflow-y: auto;
  padding: 15px;
}

.c-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  background: #F7F9FC;
  padding: 10px;
  border-radius: 10px;
}

.c-item-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 6px;
  margin-right: 10px;
  flex-shrink: 0;
}

.c-info {
  flex: 1;
  margin-left: 0;
}

.qty-box {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 6px;
}

.q-btn {
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  color: #2D3436;
}

.q-btn:hover {
  background: #f0f0f0;
}

.q-num {
  width: 24px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
}

.cart-footer {
  padding: 20px;
  background: white;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.03);
}

.checkout-btn {
  width: 100%;
  border: none;
  padding: 15px;
  margin-top: 15px;
  border-radius: 12px;
  background: #2D3436;
  color: white;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
}

.checkout-btn:hover:not(:disabled) {
  background: #1a1e21;
}

.checkout-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.tool-chip {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid #ccc;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.tool-chip.active {
  background: #2D3436;
  color: white;
  border-color: #2D3436;
}

.tool-chip:hover {
  background: #f0f0f0;
}

.tool-chip.active:hover {
  background: #1a1e21;
}

.member-info-section {
  padding: 10px 20px;
  background: #FFF5F5;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}

.member-text {
  color: #2D3436;
  flex: 1;
}
</style>

